import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import './ViewerCountBadge.css';

/**
 * ViewerCountBadge - Displays the number of viewers and a tooltip with viewer details
 * @param {Object} props
 * @param {string} props.itemId - The ID of the item being viewed (documentId or taskId)
 * @param {Function} props.getViewerCount - Function to get viewer count for an item
 * @param {Function} props.getViewers - Function to get viewer list for an item
 * @param {Array} props.activeUsers - List of active users for name/email lookup
 * @param {Object} props.user - Current user object
 * @param {string} props.itemType - Type of item ('document' or 'task') for tooltip text
 */
const ViewerCountBadge = ({ 
  itemId, 
  getViewerCount, 
  getViewers, 
  activeUsers = [], 
  user,
  itemType = 'item'
}) => {
  const viewers = getViewers(itemId);
  const viewerCount = getViewerCount(itemId);

  return (
    <div className="viewer-count">
      <FontAwesomeIcon icon={faEye} />
      <span className="viewer-count-number">{viewerCount}</span>
      <div className="viewer-tooltip">
        {(() => {
          if (viewerCount === 0) {
            return (
              <div className="viewer-tooltip-content">
                No viewers currently viewing this {itemType}
              </div>
            );
          }
          
          return (
            <div className="viewer-tooltip-content">
              <div className="viewer-tooltip-header">
                {viewerCount} currently viewing:
              </div>
              <div className="viewer-list">
                {viewers.map((viewer, index) => {
                  const viewerUser = activeUsers.find(u => u.userId === viewer.userId);
                  const isCurrentUser = viewer.userId === user?.userId;
                  return (
                    <div key={viewer.userId || index} className="viewer-item">
                      <div className="viewer-name">
                        {viewerUser?.name || 'Unknown User'}
                        {isCurrentUser && <span className="current-user-indicator"> (you)</span>}
                      </div>
                      {viewerUser?.email && <div className="viewer-email">{viewerUser.email}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default ViewerCountBadge;
